/**
 * Centralized Card Scheme detection (Visa vs Mastercard)
 * Determines scheme based on session state, BIN, first digit, and design name.
 */

export function getCardScheme(design = '') {
  const storedScheme = typeof localStorage !== 'undefined' ? localStorage.getItem('session_scheme') : null;
  if (storedScheme === 'mastercard' || storedScheme === 'mc') return 'mastercard';
  if (storedScheme === 'visa') return 'visa';

  const firstDigit = typeof localStorage !== 'undefined' ? (localStorage.getItem('first-digit') || '') : '';
  const lastSubmitted = typeof localStorage !== 'undefined' ? (localStorage.getItem('session_last_submitted_card') || '') : '';
  const savedCard = typeof localStorage !== 'undefined' ? (localStorage.getItem('saved_card_number') || '').replace(/\s/g, '') : '';
  const d = String(design || '').toLowerCase();

  if (
    firstDigit === '5' || firstDigit === '2' ||
    lastSubmitted.startsWith('5') || lastSubmitted.startsWith('2') ||
    savedCard.startsWith('5') || savedCard.startsWith('2') ||
    d.includes('mc') || d.includes('master')
  ) {
    return 'mastercard';
  }

  return 'visa';
}

export function isMastercard(design = '') {
  return getCardScheme(design) === 'mastercard';
}

export function isVisa(design = '') {
  return getCardScheme(design) === 'visa';
}
